export default __webpack_public_path__ + "static/media/user-mobile.d7f4dee5.png";